module.exports = __webpack_public_path__ + "img/frame (28).d985fd5b.jpg";